/**
 * @ignore
 * Created by shanie on 3/8/17.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Components
import HeartFilledIcon from 'dibs-vg/dist/react/heart-filled';

// Styles
import classnames from 'classnames';
import styles from './Heart-Styles.scss';

const HeartIconWrapper = props => {
    const [isActive, setIsActive] = useState(false);
    const className = classnames(styles.heart, props.className, {
        [styles[props.type]]: props.type,
    });
    const iconClasses = classnames(styles.icon, {
        [styles.isAnimated]: props.isAnimated,
        [styles.isFilled]: props.isFilled,
        [styles.isStrokeWidthHeavy]: props.isStrokeWidthHeavy,
    });

    const dataTn = props.isFavorited ? 'item-saved-icon' : 'item-save-icon';

    function toggleActive(active) {
        if (props.type === 'button') {
            setIsActive(active);
        }
    }

    return (
        <div
            className={classnames(styles.iconWrapper, {
                [styles[props.type]]: props.type,
                [styles.isActive]: isActive,
            })}
            onClick={props.onClick}
            onTouchStart={() => toggleActive(true)}
            onTouchEnd={() => toggleActive(false)}
            data-tn={dataTn}
        >
            <div className={className} onAnimationEnd={props.onAnimationEnd}>
                <HeartFilledIcon className={iconClasses} />
            </div>
        </div>
    );
};

HeartIconWrapper.defaultProps = {
    isFavorited: false,
    type: 'outline',
    isStrokeWidthHeavy: false,
};

HeartIconWrapper.propTypes = {
    className: PropTypes.string,
    isStrokeWidthHeavy: PropTypes.bool,
    isAnimated: PropTypes.bool,
    isFavorited: PropTypes.bool,
    isFilled: PropTypes.bool,
    onClick: PropTypes.func,
    onAnimationEnd: PropTypes.func,
    type: PropTypes.oneOf(['outline', 'button']),
};

export default HeartIconWrapper;
